import '.o{display:flex;}.ssr-plugin'
import '.d3{flex-direction:row;}.ssr-plugin'
import '.cb{gap:12px;}.ssr-plugin'
import '.cr{margin-bottom:24px;}.ssr-plugin'
import '.bn{opacity:0.5;}.ssr-plugin'
import '.cd{font-size:16px;}.ssr-plugin'
import '.d4{margin-top:1px;}.ssr-plugin'
import { styled } from 'inlines'
import { Icon } from '../assets/icons/index.js'
import { TABLET } from '../utils/breakpoints.js'

export const InfoRow = ({ children }: { children: React.ReactNode }) => (
  <styled.div className="o d3 cb cr"
    style={{
      [TABLET]: { marginBottom: 16 },
    }}
  >
    <Icon
      type="infoIcon"
      style={{ opacity: 0.5, minWidth: 24, minHeight: 24 }}
    />
    <p className="bn cd d4">
      {children}
    </p>
  </styled.div>
)
